import { render, staticRenderFns } from "./right_result.vue?vue&type=template&id=56bf3640&scoped=true"
import script from "./right_result.vue?vue&type=script&lang=js"
export * from "./right_result.vue?vue&type=script&lang=js"
import style0 from "./right_result.vue?vue&type=style&index=0&id=56bf3640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf3640",
  null
  
)

export default component.exports